<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="90%" top="10vh" :title="title" @close="close" @open="open">
    <div v-loading="meta.loading">
      {{ infoDetail }}
      <feeTable ref="feeRef" style="margin-top:10px;height: 35rem;" :infoDetail="infoDetail" @save="save" @del="del"></feeTable>
      </div>
      <div slot="footer">
        <el-row style="margin-top: 20px; text-align: right">
          <el-button :loading="meta.loading" @click="$refs.feeRef.save()" style="margin-right: 1rem" type="primary"  size="large">录入</el-button>
          <el-button type="info" size="large" @click.native="$emit('close')" style="margin-right: 1rem">关闭</el-button>
        </el-row>
      </div>
  </hic-dialog>
</template>
  
  <script>
  import api from "./api";  
  import { mapGetters } from "sw-hic";
  export default {
    components: {
      feeTable: () => import("./_table"),
    },
    props: {
      title: String,
      visible: Boolean,
      infoDetail:Object
    },
    data() {
      return {
        selIndex:0,
        meta:{
          loading:false,
          showBed:false
        },
        condition:{},
        list:[],
        feeItems:[]
      };
    },
    computed: {
      ...mapGetters(["dict", , "Enum", "dictEnum","user"])
    },
    filters:{
    },
    watch:{
      // infoDetail(val){
      //   if(val.id) this.open()
      // }
    },
    mounted() {
      
    },
    methods: {
      open(){
        this.condition.ipNo = this.infoDetail.ipNo
        this.condition.deptCode = this.user.deptCode;
        this.query() 
      },
  
      close() {
        this.$emit("update:visible", false);
      },
      query() {       
        this.meta.loading = true;
        api.Billing.query(this.condition)
          .then((res) => {
            this.list = res.items;
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      save(row){
        let data = row || this.list[this.list.length-1]
        if(!data.name) return this.$message.error('请选择收费项目')
        if(!data.quantity) return this.$message.error('请输入数量')        
        this.meta.loading = true;
        api.Billing.save(data)
          .then((res) => {
            this.$message.success('保存成功');
            this.$emit("update", false);
            this.query();
            // this.clear();
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      del(id){
        this.$confirm("确定要删除该记录？", "取消", { type: "warning" })
          .then(() => {
            this.meta.loading = true;
            api.Billing.del(id)
              .then((res) => {
                this.meta.loading = false;
                this.$message.success("删除成功");
                this.$emit("update", false);
                this.query();
              })
              .catch((err) => {
                self.meta.loading = false;
                self.$message.error(err);
              });
          })
          .catch((e) => {});
      }
    },
  };
  </script>